'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'chimney';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f78b';
var svgPathData = 'M16 48l0 96 416 0 0-96L16 48zM0 32l16 0 416 0 16 0 0 16 0 96 0 16-16 0-16 0 0 104 0 112 0 96 0 8-16 0 0-8 0-88-120 0-104 0 0 88 0 8-16 0 0-8 0-88L48 384l0 88 0 8-16 0 0-8 0-96 0-112 0-104-16 0L0 160l0-16L0 48 0 32zM48 160l0 96 112 0 0-96L48 160zm128 0l0 96 104 0 120 0 0-96-224 0zm-8 208l104 0 0-96-104 0L48 272l0 96 120 0zm120 0l112 0 0-96-112 0 0 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;